const initialState = {
  tooltips: {},
  userList: [],
  pendingEmailsCount: 0,
}

export default function boards(state = initialState, action) {
  switch (action.type) {
    case "CACHE_TICKET_TOOLTIP":
      return {
        ...state,
        tooltips: {
          ...state.tooltips,
          [action.ticketId]: action.payload,
        },
      }
    case "ADD_USER_LIST":
      return {
        ...state,
        userList: action.payload,
      }

    case "TICKETING_SET_PENDING_EMAIL_COUNT":
      return {
        ...state,
        pendingEmailsCount: action.ticketCount,
      }
    default:
      return state
  }
}
